"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyMaxLines = void 0;
var styled_components_1 = require("styled-components");
exports.applyMaxLines = function (_a) {
    var maxLines = _a.maxLines;
    return maxLines && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: -webkit-box;\n        overflow: hidden;\n        box-sizing: border-box;\n\n        white-space: normal;\n\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: ", ";\n    "], ["\n        display: -webkit-box;\n        overflow: hidden;\n        box-sizing: border-box;\n\n        white-space: normal;\n\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: ", ";\n    "])), maxLines);
};
var templateObject_1;
//# sourceMappingURL=applyMaxLines.js.map